<ngx-guided-tour
  skipText="Pular tour"
  nextText="Próximo"
  backText="Anterior"
  doneText="Ok, entendi!"
  [minimalTourStepWidth]="450"
  [tourStepWidth]="450"
  [progressIndicatorLocation]="topOfTourBlock"
  [progressIndicator]="progressIndicator"
>
</ngx-guided-tour>

<ng-template #progressIndicator>
  {{ tourService.currentTourStepDisplay }} de
  {{ tourService.currentTourStepCount }}
</ng-template>

<pl-fake-data-table [isButtonActive]="active"></pl-fake-data-table>
